'use strict';

var agent_browser = () => {
};

module.exports = agent_browser;
